import {
  GET_SPAREPART_REQUEST_REASONS,
  TMachineIssueTicketsFetchReason,
  TMaintenanceTicketsFetchReason,
  TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST,
  TRESPONSE_GET_ALL_EMPLOYEE_TICKETS,
  TRESPONSE_GET_ALL_MAINTENANCE_TICKETS,
  TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS,
  TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY,
  TRESPONSE_GET_MACHINE_TICKET_HISTORY,
  TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY,
  TRESPONSE_GET_SHIFT_DETAILS,
  TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE,
  TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS,
  TUserPaginationOption,
} from '@monorepo/types';

export type TTicketManagementState = {
  employeeTicketSummary: TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY | null;
  ticketSummaryAnalytics: TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS | null;
  employeeTickets: {
    res: TRESPONSE_GET_ALL_EMPLOYEE_TICKETS;
    fetchReason: TMachineIssueTicketsFetchReason;
  } | null;
  employeeTicketDetails: TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS | null;
  employeeTicketsPagination: TUserPaginationOption;
  machineTicketHistory: {
    machineIssueTickets: TRESPONSE_GET_MACHINE_TICKET_HISTORY | null;
    maintenanceTickets: TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY | null;
  };
  breakdownReasonsAndSolution: TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST | null;
  employeeRole: {
    isSupervisor: boolean;
    isMechanic: boolean;
  };
  factoryShiftDetails: TRESPONSE_GET_SHIFT_DETAILS | null;
  maintenanceTickets: {
    res: TRESPONSE_GET_ALL_MAINTENANCE_TICKETS;
    fetchReason: TMaintenanceTicketsFetchReason;
  } | null;
  maintenanceTicketsPagination: TUserPaginationOption;
  sparePartRequestsBySource: TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE | null;
  sparepartRequestReasons: null | GET_SPAREPART_REQUEST_REASONS;
};

export const TTicketManagementActionType = {
  CreateNewTicket: 'CREATE_NEW_TICKET' as const,
  CreateNewTicketSuccess: 'CREATE_NEW_TICKET_SUCCESS' as const,
  CreateNewTicketFailure: 'CREATE_NEW_TICKET_FAILURE' as const,
  AssignTicketToMe: 'ASSIGN_TICKET_TO_ME' as const,
  AssignTicketToMeSuccess: 'ASSIGN_TICKET_TO_ME_SUCCESS' as const,
  AssignTicketToMeFailure: 'ASSIGN_TICKET_TO_ME_FAILURE' as const,
  UpdateIssue: 'UPDATE_ISSUE' as const,
  UpdateIssueSuccess: 'UPDATE_ISSUE_SUCCESS' as const,
  UpdateIssueFailure: 'UPDATE_ISSUE_FAILURE' as const,
  ReAssignMechanic: 'REASSIGN_MECHANIC' as const,
  ReAssignMechanicSuccess: 'REASSIGN_MECHANIC_SUCCESS' as const,
  ReAssignMechanicFailure: 'REASSIGN_MECHANIC_FAILURE' as const,
  ReIssueTicket: 'REIUSSE_TICKET' as const,
  ReIssueTicketSuccess: 'REIUSSE_TICKET_SUCCESS' as const,
  ReIssueTicketFailure: 'REIUSSE_TICKET_FAILURE' as const,
  ApproveTicket: 'APPROVE_TICKET' as const,
  ApproveTicketSuccess: 'APPROVE_TICKET_SUCCESS' as const,
  ApproveTicketFailure: 'APPROVE_TICKET_FAILURE' as const,
  PickupTicket: 'PICKUP_TICKET' as const,
  PickupTicketSuccess: 'PICKUP_TICKET_SUCCESS' as const,
  PickupTicketFailure: 'PICKUP_TICKET_FAILURE' as const,
  MarkTicketAsCompleted: 'MARK_TICKET_COMPLETED' as const,
  MarkTicketAsCompletedSuccess: 'MARK_TICKET_COMPLETED_SUCCESS' as const,
  MarkTicketAsCompletedFailure: 'MARK_TICKET_COMPLETED_FAILURE' as const,
  ResetEmployeeTickets: 'RESET_EMPLOYEE_TICKETS' as const,
  GetAllEmployeeTickets: 'GET_ALL_EMPLOYEE_TICKETS' as const,
  GetAllEmployeeTicketsSuccess: 'GET_ALL_EMPLOYEE_TICKETS_SUCCESS' as const,
  GetAllEmployeeTicketsFailure: 'GET_ALL_EMPLOYEE_TICKETS_FAILURE' as const,
  GetEmployeeTicketDetails: 'GET_EMPLOYEE_TICKET_DETAILS' as const,
  GetEmployeeTicketDetailsSuccess: 'GET_EMPLOYEE_TICKET_DETAILS_SUCCESS' as const,
  GetEmployeeTicketDetailsFailure: 'GET_EMPLOYEE_TICKET_DETAILS_FAILURE' as const,
  GetMachineTicketHistory: 'GET_MACHINE_TICKET_HISTORY' as const,
  GetMachineTicketHistorySuccess: 'GET_MACHINE_TICKET_HISTORY_SUCCESS' as const,
  GetMachineTicketHistoryFailure: 'GET_MACHINE_TICKET_HISTORY_FAILURE' as const,
  GetMachineMaintenanceHistory: 'GET_MACHINE_MAINTENANCE_HISTORY' as const,
  GetMachineMaintenanceHistorySuccess: 'GET_MACHINE_MAINTENANCE_HISTORY_SUCCESS' as const,
  GetMachineMaintenanceHistoryFailure: 'GET_MACHINE_MAINTENANCE_HISTORY_FAILURE' as const,
  GetEmployeeTicketSummary: 'EMPLOYEE_TICKET_SUMMARY' as const,
  GetEmployeeTicketSummarySuccess: 'EMPLOYEE_TICKET_SUMMARY_SUCCESS' as const,
  GetEmployeeTicketSummaryFailure: 'EMPLOYEE_TICKET_SUMMARY_FAILURE' as const,
  GetTicketSummaryAnalytics: 'TICKET_SUMMARY_ANALYTICS' as const,
  GetTicketSummaryAnalyticsSuccess: 'TICKET_SUMMARY_ANALYTICS_SUCCESS' as const,
  GetTicketSummaryAnalyticsFailure: 'TICKET_SUMMARY_ANALYTICS_FAILURE' as const,
  GetBreakdownReasonAndSolutions: 'GET_BREAKDOWN_REASON_AND_SOLUTIONS' as const,
  GetBreakdownReasonAndSolutionsSuccess: 'GET_BREAKDOWN_REASON_AND_SOLUTIONS_SUCCESS' as const,
  GetBreakdownReasonAndSolutionsFailure: 'GET_BREAKDOWN_REASON_AND_SOLUTIONS_FAILURE' as const,
  GetFactoryShiftRevisionDetails: 'GET_FACTORY_SHIFT_DETAILS' as const,
  GetFactoryShiftRevisionDetailsSuccess: 'GET_FACTORY_SHIFT_DETAILS_SUCCESS' as const,
  GetFactoryShiftRevisionDetailsFailure: 'GET_FACTORY_SHIFT_DETAILS_FAILURE' as const,
  UpdateShiftRevision: 'UPDATE_SHIFT_REVISION' as const,
  UpdateShiftRevisionSuccess: 'UPDATE_SHIFT_REVISION_SUCCESS' as const,
  UpdateShiftRevisionFailure: 'UPDATE_SHIFT_REVISION_FAILURE' as const,
  DeleteShiftRevision: 'DELETE_SHIFT_REVISION' as const,
  DeleteShiftRevisionSuccess: 'DELETE_SHIFT_REVISION_SUCCESS' as const,
  DeleteShiftRevisionFailure: 'DELETE_SHIFT_REVISION_FAILURE' as const,
  GetAllMaintenanceTickets: 'GET_ALL_MAINTENANCE_TICKETS' as const,
  GetAllMaintenanceTicketsSuccess: 'GET_ALL_MAINTENANCE_TICKETS_SUCCESS' as const,
  GetAllMaintenanceTicketsFailure: 'GET_ALL_MAINTENANCE_TICKETS_FAILURE' as const,
  CreateMaintenanceTicket: 'CREATE_MAINTENANCE_TICKET' as const,
  CreateMaintenanceTicketSuccess: 'CREATE_MAINTENANCE_TICKET_SUCCESS' as const,
  CreateMaintenanceTicketFailure: 'CREATE_MAINTENANCE_TICKET_FAILURE' as const,
  StartMaintenanceTicket: 'START_MAINTENANCE_TICKET' as const,
  StartMaintenanceTicketSuccess: 'START_MAINTENANCE_TICKET_SUCCESS' as const,
  StartMaintenanceTicketFailure: 'START_MAINTENANCE_TICKET_FAILURE' as const,
  CompleteMaintenanceTicket: 'COMPLETE_MAINTENANCE_TICKET' as const,
  CompleteMaintenanceTicketSuccess: 'COMPLETE_MAINTENANCE_TICKET_SUCCESS' as const,
  CompleteMaintenanceTicketFailure: 'COMPLETE_MAINTENANCE_TICKET_FAILURE' as const,
  ReAssignMaintenanceMechanic: 'REASSIGN_MAINTENANCE_MECHANIC' as const,
  ReAssignMaintenanceMechanicSuccess: 'REASSIGN_MAINTENANCE_MECHANIC_SUCCESS' as const,
  ReAssignMaintenanceMechanicFailure: 'REASSIGN_MAINTENANCE_MECHANIC_FAILURE' as const,
  ResetSparepartSearches: 'RESET_SPAREPART_SEARCHES' as const,
  SearchSparepartNames: 'SEARCH_SPAREPART_NAMES' as const,
  SearchSparepartNamesSuccess: 'SEARCH_SPAREPART_NAMES_SUCCESS' as const,
  SearchSparepartNamesFailure: 'SEARCH_SPAREPART_NAMES_FAILURE' as const,
  SearchSparepartSpecifications: 'SEARCH_SPAREPART_SPECIFICATIONS' as const,
  SearchSparepartSpecificationsSuccess: 'SEARCH_SPAREPART_SPECIFICATIONS_SUCCESS' as const,
  SearchSparepartSpecificationsFailure: 'SEARCH_SPAREPART_SPECIFICATIONS_FAILURE' as const,
  GetAllSparepartBrandsByNameAndSpecification: 'GET_SPAREPART_BRANDS_BY_NAME_AND_SPECIFICATION' as const,
  GetAllSparepartBrandsByNameAndSpecificationSuccess: 'GET_SPAREPART_BRANDS_BY_NAME_AND_SPECIFICATION_SUCCESS' as const,
  GetAllSparepartBrandsByNameAndSpecificationFailure: 'GET_SPAREPART_BRANDS_BY_NAME_AND_SPECIFICATION_FAILURE' as const,
  GetSparepartRequestBySource: 'GET_SPAREPART_REQUEST_BY_SOURCE' as const,
  ResetSparepartRequestDetails: 'RESET_SPAREPART_REQUEST_DETAILS' as const,
  GetSparepartRequestBySourceSuccess: 'GET_SPAREPART_REQUEST_BY_SOURCE_SUCCESS' as const,
  GetSparepartRequestBySourceFailure: 'GET_SPAREPART_REQUEST_BY_SOURCE_FAILURE' as const,
  CancelSparepartRequest: 'CANCEL_SPAREPART_REQUEST' as const,
  CancelSparepartRequestSuccess: 'CANCEL_SPAREPART_REQUEST_SUCCESS' as const,
  CancelSparepartRequestFailure: 'CANCEL_SPAREPART_REQUEST_FAILURE' as const,
  GetSparepartRequestReasons: 'GET_SPAREPART_REQUEST_REASONS' as const,
  GetSparepartRequestReasonsSuccess: 'GET_SPAREPART_REQUEST_REASONS_SUCCESS' as const,
  GetSparepartRequestReasonsFailure: 'GET_SPAREPART_REQUEST_REASONS_FAILURE' as const,
  MarkChecklistCompleted: 'MARK_CHECKLIST_COMPLETED' as const,
  MarkChecklistCompletedSuccess: 'MARK_CHECKLIST_COMPLETED_SUCCESS' as const,
  MarkChecklistCompletedFailure: 'MARK_CHECKLIST_COMPLETED_FAILURE' as const,
  SetEmployeeTicketsPagination: 'SET_EMPLOYEE_TICKETS_PAGINATION' as const,
  SetMaintenanceTicketsPagination: 'SET_MAINTENANCE_TICKETS_PAGINATION' as const,
};
